import { render, staticRenderFns } from "./outlet.vue?vue&type=template&id=12d6f773&scoped=true"
import script from "./outlet.vue?vue&type=script&lang=js"
export * from "./outlet.vue?vue&type=script&lang=js"
import style0 from "./outlet.vue?vue&type=style&index=0&id=12d6f773&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d6f773",
  null
  
)

export default component.exports